<template>
  <div class="grid min-h-svh lg:grid-cols-10 py-4 pl-4 pr-4 md:pr-8">
    <div
      class="col-span-4 w-full h-full relative hidden lg:flex flex-col items-center justify-between rtl:order-1"
    >
      <div
        class="w-full h-full bg-image bg-green !rounded-[32px] overflow-hidden"
      />
    </div>
    <div
      class="relative flex col-span-6 items-center flex-col justify-between pt-14 pb-2 gap-4"
    >
      <div
        class="absolute right-0 top-0 md:top-5 w-full lg:w-[80%] flex items-end md:items-center justify-between flex-col md:flex-row gap-6 md:gap-0"
      >
        <div class="flex items-center justify-between md:w-auto w-full">
          <LocalizedLink to="/home" class="md:hidden">
            <img src="/logo/saraf-logo-dark.svg" alt="Saraf Logo" />
          </LocalizedLink>
          <CLanguageSwitcher class="" />
        </div>
        <CAuthSwitcher />
      </div>
      <div class="w-full mx-auto flex flex-1 items-center justify-center mt-20">
        <Transition name="dropdown" mode="out-in">
          <slot />
        </Transition>
      </div>
      <div class="text-center flex flex-col gap-3 w-full">
        <RouterLink
          :to="`/${staticPages?.[1]?.slug}`"
          class="text-sm font-normal text-gray-500 leading-normal hover:text-green"
        >
          {{ $t("privacy_policy") }}
        </RouterLink>
        <p class="text-sm leading-normal text-gray-500">
          {{ $t("version") }} {{ CONFIG.APP_VERSION }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import LocalizedLink from "@/components/CLocalizedLink.vue";

import { CONFIG } from "@/config";
import { computed } from "vue";
import CLanguageSwitcher from "@/components/CLanguageSwitcher.vue";
import { useCommonStore } from "@/modules/Pages/stores";
import CAuthSwitcher from "@/layout/Auth/components/CAuthSwitcher.vue";

const commonStore = useCommonStore();
commonStore.fetchStaticPages();

const staticPages = computed(() => commonStore.data?.results);
</script>

<style scoped>
.min-h-svh {
  min-height: 100svh;
}
.bg-image {
  background-image: url("/images/auth-overlay.webp");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
</style>
